import PropTypes from 'prop-types'
import HorizontalGallery from '../../../public_obituary/photo_gallery/HorizontalGallery'
import StandardGallery from '../../../public_obituary/photo_gallery/StandardGallery'
import VintageGallery from '../../../public_obituary/photo_gallery/VintageGallery'

function GalleryLayout({ templateName, obituary, ...props }) {

    const Template = {
        VintageGallery,
        StandardGallery,
        HorizontalGallery
    }[templateName]

    return Template
        ? <Template obituary={obituary} {...props} />
        : <div>Template not found: {templateName}</div>
}

GalleryLayout.defaultProps = {
    obituary: {
        id: 1,
        display_name: 'John Doe',
        first_name: 'John',
        last_name: 'Doe',
        gallery_photos: Array.from({ length: 9 }, (_, index) => {
            const imageNumber = index + 1;
            const imagePath = `/img/photo_gallery/gallery${imageNumber}.png`;
            return {
                xl: imagePath,
                md: imagePath
            };
        })
    },
    templateName: 'StandardGallery'
}

GalleryLayout.propTypes = {
    obituary: PropTypes.object,
    templateName: PropTypes.string
}

export default GalleryLayout 